var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-loading",
            {
              attrs: {
                loading: _vm.loading,
                type: "list-item"
              }
            },
            [
              _c(
                "div",
                [
                  !_vm.loading
                    ? _c(
                        "gg-card",
                        {
                          attrs: {
                            outlined: _vm.text
                          }
                        },
                        [
                          _c(
                            "gg-card-text",
                            [
                              _c(
                                "v-row",
                                {
                                  class: _vm.unpaidRowClass
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "billing"
                                            }
                                          }
                                        },
                                        [_vm._v("← Back to Invoices")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-center",
                                      attrs: {
                                        cols: "12",
                                        sm: "6"
                                      }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "text-left ma-0"
                                        },
                                        [
                                          _vm._v(
                                            " Invoice #" +
                                              _vm._s(_vm.invoice.id) +
                                              " "
                                          ),
                                          _c(
                                            "v-chip",
                                            {
                                              staticClass: "ma-2 my-0",
                                              staticStyle: {
                                                "border-radius": "0"
                                              },
                                              attrs: {
                                                tile: "",
                                                color: "".concat(
                                                  _vm.isInvoiceUnpaid
                                                    ? "red"
                                                    : "green",
                                                  " lighten-1"
                                                ),
                                                "text-color": "white"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  attrs: {
                                                    left: ""
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.isInvoiceUnpaid
                                                            ? "mdi-information-outline"
                                                            : "mdi-check-bold"
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.invoice.status) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("br"),
                                      _c("p", [
                                        _c("strong", [
                                          _vm._v("Date Generated:")
                                        ]),
                                        _vm._v(
                                          " " + _vm._s(_vm.invoice.date) + " "
                                        )
                                      ]),
                                      _c("p", [
                                        _c("strong", [_vm._v("Due Date:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.invoice.duedate) +
                                            " "
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "align-center text-sm-right d-inline",
                                      attrs: {
                                        cols: "12",
                                        sm: "6"
                                      }
                                    },
                                    [
                                      _vm.isInvoiceUnpaid && !_vm.text
                                        ? _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                tile: "",
                                                disabled:
                                                  _vm.invoice.balance == 0
                                              },
                                              on: {
                                                click: _vm.openPaymentsModal
                                              }
                                            },
                                            [_vm._v(" Pay Now ")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "gg-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.text,
                                              expression: "!text"
                                            }
                                          ],
                                          staticClass: "ml-2",
                                          attrs: {
                                            secondary: "",
                                            to: {
                                              name: "print_invoice",
                                              params: {
                                                invoiceid: _vm.invoice.id
                                              }
                                            },
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(" Print ")]
                                      ),
                                      _c("br"),
                                      _c("br")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-loading",
            {
              attrs: {
                loading: _vm.loading,
                type: "table"
              }
            },
            [
              _c(
                "div",
                [
                  !_vm.loading
                    ? _c(
                        "gg-card",
                        {
                          attrs: {
                            outlined: _vm.text
                          }
                        },
                        [
                          _c(
                            "gg-card-text",
                            [
                              _c(
                                "v-row",
                                {
                                  class: _vm.unpaidRowClass
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c("h4", [_vm._v("Customer Address:")]),
                                      _c("address", [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.decodeHtmlCharCodes(
                                                _vm.contact.firstname
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.decodeHtmlCharCodes(
                                                  _vm.contact.lastname
                                                )
                                              )
                                          )
                                        ]),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.decodeHtmlCharCodes(
                                                _vm.contact.companyname
                                              )
                                            )
                                          )
                                        ]),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.decodeHtmlCharCodes(
                                                _vm.contact.address1
                                              )
                                            )
                                          )
                                        ]),
                                        _vm.contact.address2
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.decodeHtmlCharCodes(
                                                    _vm.contact.address2
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.decodeHtmlCharCodes(
                                                _vm.contact.city
                                              )
                                            ) +
                                              ", " +
                                              _vm._s(
                                                _vm.decodeHtmlCharCodes(
                                                  _vm.contact.state
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.decodeHtmlCharCodes(
                                                  _vm.contact.postcode
                                                )
                                              ) +
                                              ", " +
                                              _vm._s(
                                                _vm.decodeHtmlCharCodes(
                                                  _vm.contact.country
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c("h4", [_vm._v("Payable to:")]),
                                      _c("address", [
                                        _c("div", [_vm._v("GreenGeeks LLC")]),
                                        _c("div", [
                                          _vm._v("3411 Silverside Rd")
                                        ]),
                                        _c("div", [
                                          _vm._v("Tatnall Building #104")
                                        ]),
                                        _c("div", [
                                          _vm._v("Wilmington, DE 19810, USA.")
                                        ]),
                                        _c("div", [
                                          _c("strong", [_vm._v("Tax ID: ")]),
                                          _vm._v("85-3680919")
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "table-dark",
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "invoice-table-row",
                                        attrs: {
                                          headers: _vm.invoice_headers,
                                          items: _vm.invoice.lines,
                                          "hide-default-footer": "",
                                          "items-per-page": _vm.itemsPerPage
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item.description",
                                              fn: function fn(_ref) {
                                                var item = _ref.item
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.decodeHtmlCharCodes(
                                                          item.description
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2614073337
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "6",
                                        offset: "6",
                                        sm: "4",
                                        "offset-sm": "8"
                                      }
                                    },
                                    [
                                      _c("v-simple-table", {
                                        staticClass: "invoice-table-row",
                                        attrs: {
                                          dense: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function fn() {
                                                return [
                                                  _c("tbody", [
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Subtotal")
                                                      ]),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.invoice
                                                                .subtotal
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Taxes")
                                                      ]),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.invoice.tax
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Grand Total")
                                                      ]),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.invoice.total
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]),
                                                    _vm.invoice.balance > 0
                                                      ? _c("tr", [
                                                          _c("td", [
                                                            _vm._v(
                                                              "Balance Outstanding"
                                                            )
                                                          ]),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.invoice
                                                                    .balance
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ])
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          1473941027
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }